import { useEffect } from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import TodoApp from "./components/TodoApp";
import { ProtectedRoute } from "./route/ProtectedRoute";
import { AuthProvider } from "./store/AuthContext";

function ProtectedAppShell() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/app") {
      navigate("/app/", { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <ProtectedRoute>
      <TodoApp />
    </ProtectedRoute>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/app/" replace />} />
          <Route path="/app" element={<Navigate to="/app/" replace />} />
          <Route path="/app/*" element={<ProtectedAppShell />} />
          <Route path="*" element={<Navigate to="/app/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
